import React from "react";
import styled, { keyframes } from "styled-components";
import { useColorTokens } from "@tvg/design-system";

const pulseAnimation = keyframes`
  0% {
    opacity: 1
  }

  50% {
    opacity: 0.5
  }

  100% {
    opacity: 1
  }
`;

const SVG = styled.svg`
  animation: ${pulseAnimation} 1.25s infinite;
`;

const BetTypeSelectorLoading = () => {
  const colorToken = useColorTokens();

  return (
    <SVG
      data-qa-label="bet-type-selector-loading"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="65"
      viewBox="0 0 469 65"
      fill="none"
      preserveAspectRatio="none"
    >
      <rect width="469" height="65" fill="transparent" />
      <rect
        width="469"
        height="32"
        rx="4"
        fill={colorToken.content.loadingDefault}
      />
      <rect
        width="374"
        height="25"
        transform="translate(0 40)"
        fill={colorToken.content.loadingDefault}
      />
    </SVG>
  );
};

export default BetTypeSelectorLoading;
